import { render, staticRenderFns } from "./pick-header.vue?vue&type=template&id=c253264a&scoped=true"
import script from "./pick-header.vue?vue&type=script&lang=ts"
export * from "./pick-header.vue?vue&type=script&lang=ts"
import style0 from "./pick-header.vue?vue&type=style&index=0&id=c253264a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c253264a",
  null
  
)

export default component.exports